import _ from 'underscore';

export function splitInLevels(concepts) {
  return _.groupBy(concepts, 'level');
}

export function getParentName(concept, concepts) {
  const parent = _.find(concepts['1'], { id: concept.parent_id, });
  const grandParent = _.find(concepts['2'], { id: parent.parent_id, });
  return `${grandParent.name} | ${parent.name}`;
}
